import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "container-fluid h-100" };
const _hoisted_2 = { class: "row h-100" };
const _hoisted_3 = { class: "col-6" };
const _hoisted_4 = {
    key: 0,
    class: "container"
};
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "col-9" };
const _hoisted_7 = { class: "d-flex" };
const _hoisted_8 = { class: "col-6 border bg-light" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_form = _resolveComponent("g-form");
    const _component_g_monaco_editor = _resolveComponent("g-monaco-editor");
    const _component_g_scroll_box = _resolveComponent("g-scroll-box");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_g_text_field, {
                    "data-object": _ctx.$data,
                    "data-member": "path",
                    "data-mode": "model",
                    label: "Pfad"
                }, null, 8, ["data-object"]),
                _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "mt-2" }, null, -1)),
                (_ctx.entity?.items)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entity.items, (segment) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-3" }, " Segment: ", -1)),
                                _createElementVNode("div", _hoisted_6, [
                                    _createTextVNode(" Mode: " + _toDisplayString(segment.mode), 1),
                                    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" name: " + _toDisplayString(segment.name), 1),
                                    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" path: " + _toDisplayString(segment.path), 1),
                                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" query: " + _toDisplayString(segment.query), 1),
                                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" index: " + _toDisplayString(segment.index), 1),
                                    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                    _cache[7] || (_cache[7] = _createTextVNode(" navigation: ", -1)),
                                    _createElementVNode("pre", null, _toDisplayString(_ctx.getJson(segment.navigation)), 1),
                                    _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                                    _cache[9] || (_cache[9] = _createTextVNode(" entity: ", -1)),
                                    _createElementVNode("pre", null, _toDisplayString(_ctx.getJson(segment.entity)), 1),
                                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1))
                                ])
                            ]));
                        }), 256))
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_g_form, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_g_text_field, {
                            "data-object": _ctx.$data,
                            "data-member": "navigation.mode",
                            "data-mode": "model",
                            label: "Fenster: Modus"
                        }, null, 8, ["data-object"]),
                        _createVNode(_component_g_text_field, {
                            "data-object": _ctx.$data,
                            "data-member": "navigation.location",
                            "data-mode": "model",
                            label: "Entity: Location"
                        }, null, 8, ["data-object"]),
                        _createVNode(_component_g_text_field, {
                            "data-object": _ctx.$data,
                            "data-member": "navigation.size",
                            "data-mode": "model",
                            label: "Entity: Size"
                        }, null, 8, ["data-object"]),
                        _createVNode(_component_g_text_field, {
                            "data-object": _ctx.$data,
                            "data-member": "entity.name",
                            "data-mode": "model",
                            label: "Entity: Name"
                        }, null, 8, ["data-object"]),
                        _createVNode(_component_g_text_field, {
                            "data-object": _ctx.$data,
                            "data-member": "entity.mode",
                            "data-mode": "model",
                            label: "Entity: Modus"
                        }, null, 8, ["data-object"]),
                        _createVNode(_component_g_text_field, {
                            "data-object": _ctx.$data,
                            "data-member": "entity.id",
                            "data-mode": "model",
                            label: "Entity: ID"
                        }, null, 8, ["data-object"]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.update && _ctx.update(...args)), ["stop", "prevent"]))
                            }, "Aktualisieren"),
                            _createElementVNode("button", {
                                class: "btn btn-outline-danger ms-2",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(
                                //@ts-ignore
                                (...args) => (_ctx.close && _ctx.close(...args)), ["stop", "prevent"]))
                            }, "Schließen")
                        ])
                    ]),
                    _: 1
                })
            ]),
            _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_g_scroll_box, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_g_monaco_editor, {
                            language: "json",
                            value: _ctx.content,
                            "read-only": true
                        }, null, 8, ["value"])
                    ]),
                    _: 1
                })
            ])
        ])
    ]));
}
